import {
  EnterLayoutPage,
  LoginPage,
  ErrorPage,
  Definitions,
} from '../pages';

import CreateUserDrawer from '../pages/definitions/Users/drawer/CreateUserDrawer';
import EditUserDrawer from '../pages/definitions/Users/drawer/EditUserDrawer';
import CreateDeviceDrawer from '../pages/definitions/Devices/drawer/CreateDeviceDrawer';
import EditDeviceDrawer from '../pages/definitions/Devices/drawer/EditDeviceDrawer';
import CreateSimcardDrawer from '../pages/definitions/SimCards/drawer/CreateSimcardDrawer';
import EditSimcardDrawer from '../pages/definitions/SimCards/drawer/EditSimcardDrawer';
import Simcards from '../pages/definitions/SimCards';
import EditProductDrawer from '../pages/definitions/Products/drawer/EditProductDrawer';
import CreateProductDrawer from '../pages/definitions/Products/drawer/CreateProductDrawer';
import Product from '../pages/definitions/Products';
import Companies from '../pages/definitions/Companies';
import CreateCompanyDrawer from '../pages/definitions/Companies/drawer/CreateCompanyDrawer';
import EditCompanyDrawer from '../pages/definitions/Companies/drawer/EditCompanyDrawer';
import Assignments from '../pages/definitions/Assignments';
import CreateAssignmentDrawer from '../pages/definitions/Assignments/drawer/CreateAssignmentDrawer';
import EditAssignmentDrawer from '../pages/definitions/Assignments/drawer/EditAssignmentDrawer';

import { Products, Users, Devices } from '../pages';

const routes = [
  {
    path: '/',
    element: <Products />,
  },
  {
    path: '/login',
    element: (
      <EnterLayoutPage>
        <LoginPage />
      </EnterLayoutPage>
    ),
  },
  {
    path: '*',
    element: <ErrorPage />,
  },

  {
    path: '/definitions/dashboard',
    element: <Definitions />,
  },
  {
    path: '/definitions/users',
    element: <Users />,
    rightDrawerElement: (
      <CreateUserDrawer />
    ),
    leftDrawerElement: (
      <EditUserDrawer />
    ),
  },
  {
    path: '/definitions/devices',
    element: <Devices />,
    rightDrawerElement: (<CreateDeviceDrawer />),
    leftDrawerElement: (<EditDeviceDrawer />),
  },
  {
    path: "definitions/simcards",
    element: <Simcards />,
    rightDrawerElement: (<CreateSimcardDrawer />),
    leftDrawerElement: (<EditSimcardDrawer />),
  },
  {
    path: "definitions/products",
    element: <Product />,
    rightDrawerElement: (<CreateProductDrawer />),
    leftDrawerElement: (<EditProductDrawer />),
  },
  {
    path: "definitions/companies",
    element: <Companies />,
    rightDrawerElement: (<CreateCompanyDrawer />),
    leftDrawerElement: (<EditCompanyDrawer />),
  },
  {
    path: "definitions/assignments",
    element: <Assignments />,
    rightDrawerElement: (<CreateAssignmentDrawer />),
    leftDrawerElement: (<EditAssignmentDrawer />),
  }
];

export default routes;
